import EigenLeadsDiagramFrame from './EigenLeadsDiagramFrame';
import { eigenLeadsPalette, elType } from './eigenLeadsPalette';
import { ElDefs, ElGrid, ElSectionLabel, ElPanel, ElBus, ElConnector } from './eigenLeadsDiagramKit';

const PREFIX = 'elChain';

const steps = [
  { id: 'territory', label: 'Territory', mono: 'define_scope', note: 'Lines · geo · targets' },
  { id: 'source', label: 'Source', mono: 'verify_ingest', note: 'Multi-source intake' },
  { id: 'score', label: 'Score', mono: 'rank_contacts', note: 'EigenScore™ applied' },
  { id: 'deliver', label: 'Deliver', mono: 'controlled_release', note: 'Pack on cadence' },
];

const EigenLeadsSupplyChainDiagram = ({ theme = 'dark' }) => {
  const isDark = theme === 'dark';
  const c = eigenLeadsPalette(isDark);

  return (
    <EigenLeadsDiagramFrame
      theme={theme}
      caption="Operated supply chain · territory to ranked queue on standard"
      className="el-chain-frame"
    >
      <svg viewBox="0 0 800 360" className="w-full h-auto el-chain-svg" role="img" aria-label="eigenLeads four-step supply chain">
        <ElDefs prefix={PREFIX} isDark={isDark} />
        <rect width="800" height="360" fill={c.bg} />
        <ElGrid width={800} height={360} rows={7} c={c} />

        <ElSectionLabel x={400} y={36} c={c}>
          OPERATED SUPPLY CHAIN
        </ElSectionLabel>

        <ElBus x1={100} y1={180} x2={700} y2={180} prefix={PREFIX} className="el-chain-bus" />
        <circle r="6" fill={c.indigo} filter={`url(#${PREFIX}-glow)`} className="el-chain-bus-dot">
          <animateMotion dur="8s" repeatCount="indefinite" path="M 100 180 L 700 180" />
        </circle>

        {steps.map(({ id, label, mono, note }, i) => {
          const x = 140 + i * 180;
          return (
            <g key={id} className={`el-chain-step el-chain-step-${i}`}>
              <circle cx={x} cy={180} r="5" fill={c.indigo} filter={`url(#${PREFIX}-glow)`} className="el-chain-step-dot" />
              <ElPanel x={x - 72} y={88} w={144} h={68} prefix={PREFIX} c={c}>
                <text x={x} y={114} textAnchor="middle" fill={c.label} {...elType.title}>
                  {label}
                </text>
                <text x={x} y={132} textAnchor="middle" fill={c.mono} {...elType.monoSm}>
                  {mono}()
                </text>
                <text x={x} y={148} textAnchor="middle" fill={c.muted} {...elType.sub}>
                  {note}
                </text>
              </ElPanel>
              <line x1={x} y1={156} x2={x} y2={174} stroke={c.panelStroke} strokeWidth="1" />
              {i < steps.length - 1 && <ElConnector x1={x + 72} y1={180} x2={x + 108} y2={180} c={c} prefix={PREFIX} />}
            </g>
          );
        })}

        <ElPanel x={48} y={220} w={704} h={56} prefix={PREFIX} c={c}>
          <text x={72} y={244} fill={c.muted} {...elType.section}>
            PROGRAM EVENTS
          </text>
          <text x={72} y={262} fill={c.mono} {...elType.monoSm} className="el-chain-events">
            territory.defined → source.verified → contact.scored → pack.certified → queue.released
          </text>
        </ElPanel>

        <ElPanel x={48} y={292} w={340} h={52} prefix={PREFIX} c={c}>
          <text x={72} y={316} fill={c.indigo} {...elType.title}>
            Shared Oxygen operates the chain
          </text>
          <text x={72} y={332} fill={c.muted} {...elType.sub}>
            Not a one-off file — a governed program
          </text>
        </ElPanel>

        <ElPanel x={412} y={292} w={340} h={52} prefix={PREFIX} c={c} active stroke={c.emerald}>
          <text x={436} y={316} fill={c.emerald} {...elType.title}>
            Pack certified before release
          </text>
          <text x={436} y={332} fill={c.mono} {...elType.monoSm}>
            QualityCert™ · documented handoff
          </text>
        </ElPanel>
      </svg>
    </EigenLeadsDiagramFrame>
  );
};

export default EigenLeadsSupplyChainDiagram;
